export default "__VITE_ASSET__DB5G7se5__"